function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var ElementCreator = /*#__PURE__*/ function() {
    "use strict";
    function ElementCreator(tagName) {
        _class_call_check(this, ElementCreator);
        _define_property(this, "element_", void 0);
        if (tagName === "svg") {
            this.element_ = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        } else {
            this.element_ = document.createElement(tagName);
        }
    }
    _create_class(ElementCreator, [
        {
            /**
     * Set the id of the element
     * @param {string} id
     * @returns HTMLElement
     */ key: "setId",
            value: function setId(id) {
                this.element_.id = id;
                return this;
            }
        },
        {
            /**
     * Set the classes of the element
     * @param {string[]} classNames
     * @returns ElementCreator
     */ key: "addClass",
            value: function addClass() {
                for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++){
                    classNames[_key] = arguments[_key];
                }
                var _this_element__classList;
                (_this_element__classList = this.element_.classList).add.apply(_this_element__classList, _to_consumable_array(classNames));
                return this;
            }
        },
        {
            /**
     * Set the attributes of the element
     * @param {{ [key: string]: string }} attributes
     * @returns
     */ key: "setAttributes",
            value: function setAttributes(attributes) {
                for(var key in attributes){
                    this.element_.setAttribute(key, attributes[key]);
                }
                return this;
            }
        },
        {
            /**
     * Build the element and return it as HTMLElement
     * @returns HTMLElement
     */ key: "build",
            value: function build() {
                return this.element_;
            }
        }
    ], [
        {
            key: "createElement",
            value: /**
     * Create a new element with the given tag name
     * @param tagName
     * @returns ElementCreator
     */ function createElement(tagName) {
                return new ElementCreator(tagName);
            }
        },
        {
            key: "createDiv",
            value: function createDiv(params) {
                return (params === null || params === void 0 ? void 0 : params.id) ? ElementCreator.createElement("div").setId(params.id) : ElementCreator.createElement("div");
            }
        },
        {
            key: "createSpan",
            value: function createSpan(params) {
                return (params === null || params === void 0 ? void 0 : params.id) ? ElementCreator.createElement("span").setId(params.id) : ElementCreator.createElement("span");
            }
        },
        {
            key: "createSVG",
            value: function createSVG(params) {
                return (params === null || params === void 0 ? void 0 : params.id) ? ElementCreator.createElement("svg").setId(params.id) : ElementCreator.createElement("svg");
            }
        },
        {
            key: "createLine",
            value: function createLine(params) {
                return (params === null || params === void 0 ? void 0 : params.id) ? ElementCreator.createElement("line").setId(params.id) : ElementCreator.createElement("line");
            }
        }
    ]);
    return ElementCreator;
}();
export { ElementCreator as default };
